<template>
  <el-dialog class="store-dialog" title="选择店铺" :visible.sync="showDialog" :close-on-click-modal="false" :before-close="cancelAction">
    <div style="margin-bottom: 15px;">
      <el-row :gutter="10">
        <el-col :span="4">
          <div style="margin-top: 10px">
            <el-checkbox v-model="params.choose_all" label="选中全部" border @change="chooseAll"></el-checkbox>
          </div>
        </el-col >
        <el-col :span="4">
        <div style="margin-top: 10px">
            <el-checkbox  label="清空选中" border @change="clearAll"></el-checkbox>
          </div>
        </el-col>
        <el-col :span="6">
          <el-input placeholder="输入店铺名称" v-model="name" clearable><el-button slot="append" icon="el-icon-search" @click="handleIconClick"></el-button></el-input>
        </el-col>
        <el-col :span="6">
          <el-input placeholder="输入店铺英克ID" v-model="number" clearable><el-button slot="append" icon="el-icon-search" @click="handleIconClickk"></el-button></el-input>
        </el-col>
        <el-col v-if="system_mode === 'platform'" :span="3">
          <el-cascader
            placeholder="选择标签"
            :options="tag.list"
            :props="{value:'tag_id', label: 'tag_name'}"
            v-model='select_tags_value'
            clearable
            @change="TagChangeAction">
          </el-cascader>
        </el-col>
        <el-col :span="6">
          <!--<el-select v-model="office_area_name"  placeholder="所属大区" @change="handleOfficeChange">-->
            <!--<el-option  v-for="item in office_area" :key="item.area_id" :label="item.name" :value="item.name" >-->
            <!--</el-option>-->
          <!--</el-select>-->
          <el-cascader placeholder="所属大区" @change="handleOfficeChange"
                       :options="new_office_area"
                       :props="{ checkStrictly: true }"
                       v-model="selected_office_area_id"
                       clearable>
          </el-cascader>
        </el-col>
        <div v-show="false">
          <el-col ><el-input v-model="office_area_id" placeholder=""></el-input></el-col>
          <el-col ><el-input v-model="office_area_pid" placeholder=""></el-input></el-col>
        </div>

      </el-row>
    </div>
    <el-table ref="multipleTable" :data="storeData" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange" v-loading="loading" :row-key="getRowKeys">
      <el-table-column type="selection" :reserve-selection="true" width="50"></el-table-column>
      <el-table-column prop="name" label="店铺名称"></el-table-column>
      <el-table-column prop="distributor_id" label="店铺ID"></el-table-column>
      <el-table-column prop="number" label="店铺英克ID"></el-table-column>
      <el-table-column prop="contact" label="联系人"></el-table-column>
      <el-table-column prop="store_name" label="门店"></el-table-column>
      <el-table-column prop="address" label="地址" show-overflow-tooltip></el-table-column>
    </el-table>
    <div v-if="total_count > params.pageSize" class="tr">
          <el-pagination
          layout="prev, pager, next"
          @current-change="handleCurrentChange"
          :total="total_count" :page-size="pageLimit">
          </el-pagination>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="cancelAction">取 消</el-button>
      <el-button type="primary" @click="saveStoreAction">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>


    import { getDistributorList, getTagList, distributorRelTags } from '@/api/marketing'
    import {getAreaManageList} from "../../api/areamanage";
  export default {
    props: {
      relDataIds: {
        type: Array,
        default: function(){
          return []
        }
      },
      getStatus: {
        type: Boolean,
        default: false
      },
      isValid: {
        type: Boolean,
        default: false
      },
      storeVisible: {
        type: Boolean,
        default: false
      },
      sourceType: {
        type: String,
        default: 'distributor'
      }
    },
    data () {
      return {
        loading: false,
        storeData: [],
        office_area_name:[],
        office_area_id:'',
        office_area_pid:'',
        new_office_area:[],
        selected_office_area_id:[],
        multipleSelection: [],
        pageLimit: 10,
        selectRows: [],
        total_count: '',
        params: {
          page: 1,
          pageSize: 10,
          is_valid: 'true',
          choose_all:false,
        },
        name: '',
        distributor_id: '', // 店铺ID
        number: '', // 店铺英克ID
        select_tags_value: '', // 店铺标签
        tag: {
          dialog: false,
          editItem: [],
          list: [],
          form: {
            tag_ids: [],
            distributor_id: []
          },
          currentTags: [],
          tags: []
        },
      }
    },
    methods: {
      chooseAll(val){
        if(val == true){
          this.$message({message: '请稍后...', type: 'warning'})
          const originalPageSize = this.params.pageSize
          this.params.pageSize = this.total_count
          getDistributorList (this.params).then(response => {
            this.params.pageSize = originalPageSize || this.pageLimit
            this.$message({message: '本次选中了'+this.total_count+'个店铺', type: 'success'})
            var data = response.data.data.list
            // this.selectRows = []
            
            // this.selectRows = data
            // this.multipleSelection = []
            // this.$refs.multipleTable.clearSelection()
            // if (this.selectRows) {
            //   this.selectRows.forEach(item => {
            //     this.$refs.multipleTable.toggleRowSelection(item)
            //   })
            // }
            this.selectRows.push(data)
            //this.multipleSelection 
            //this.$refs.multipleTable.clearSelection()
            if (data) {
              data.forEach(item => {
                this.$refs.multipleTable.toggleRowSelection(item)
              })
            }
          }).catch(() => {
            this.params.pageSize = originalPageSize || this.pageLimit
          })
        }
      },
      clearAll(){
        this.selectRows = []
        
        
        this.storeData = []
        this.multipleSelection = []
        this.$refs.multipleTable.clearSelection()
        this.$emit('chooseStore', this.multipleSelection)
        this.$message({message: '本次清空了所有选中', type: 'success'})
        
      },
      getAllTagList () {
        let params = {
          page: 1,
          pageSize: 500
        }
        getTagList(params).then(response => {
          this.tag.list = response.data.data.list
        })
      },
      /************ 根据大区搜索 ***********/
      handleOfficeChange:function (val){
        // this.office_area_name = val
        // var now_office_area_id = ''
        // office_area.map(function(value,index,array){
        //   if(value.name === val){
        //     now_office_area_id = value.area_id
        //   }
        // })
        // this.office_area_id = now_office_area_id
        // this.params.office_area_id = this.office_area_id
          var now_office_area_pid = val[0]
          this.selected_office_area_id[0] = now_office_area_pid;
          if(val.length > 1){
              var now_office_area_id = val[1]
              this.selected_office_area_id[1] = now_office_area_id
          }else{
              var now_office_area_id = 0
          }
          this.office_area_id = now_office_area_id
          this.office_area_pid = now_office_area_pid
          this.params.office_area_id = now_office_area_id
          this.params.office_area_pid = now_office_area_pid
          this.params.page = 1
        this.getNewsList()
      },

        // 新二级区域
        getnewDataAreaManage(){
            getAreaManageList({'format_flag':true}).then(response => {
                this.new_office_area =response.data.data;

            })
        },
      /**********END**************/
      TagChangeAction(value) {
        this.params.tag_id = value
        this.params.page = 1
        this.getNewsList()
      },
      getRowKeys (row) {
        return row.distributor_id
      },
      handleCurrentChange (page_num) {
        this.params.page = page_num
        this.getNewsList()
      },
      handleIconClick () {
        // 搜索时重置分页，避免沿用之前翻页的 page/pageSize 导致查不到数据
        this.params.page = 1
        this.params.pageSize = this.pageLimit
        this.params.name = this.name
        this.params.number = this.number
        this.getNewsList()
      },
      handleIconClickk () {
        // 搜索时重置分页，避免沿用之前翻页的 page/pageSize 导致查不到数据
        this.params.page = 1
        this.params.pageSize = this.pageLimit
        this.params.name = this.name
        this.params.number = this.number
        this.getNewsList()
      },
      toggleSelection (rows) {
        if (rows) {
          rows.forEach(row => {
            this.$refs.multipleTable.toggleRowSelection(row)
          })
        } else {
          this.$refs.multipleTable.clearSelection()
        }
      },
      handleSelectionChange (val) {
        //console.log(val)
        //console.log(this.selectRows)
        if (val) {
          this.multipleSelection= val
          val.forEach(item => {
            let isInArr = -1
            if (this.selectRows.length > 0) {
              isInArr = this.selectRows.findIndex((n) => n.distributor_id == item.distributor_id)
            }
            if (isInArr == -1) {
              this.selectRows.push(item)
            }
          })
        }
      },
      cancelAction () {
        this.$emit('closeStoreDialog')
      },
      saveStoreAction () {
        this.$emit('chooseStore', this.multipleSelection)
      },
      getNewsList () {
        if (this.getStatus) {
          this.loading = true
          getDistributorList (this.params).then(response => {
            this.storeData = response.data.data.list
            this.total_count = parseInt(response.data.data.total_count)
            this.loading = false
            this.multipleSelection = []
            this.$refs.multipleTable.clearSelection()
            if (this.selectRows) {
              this.selectRows.forEach(item => {
                this.$refs.multipleTable.toggleRowSelection(item)
              })
            }
          })
        }
      }
    },
    computed: {
      showDialog () {
        return this.storeVisible
      }
    },
    watch: {
      relDataIds (newVal, oldVal){
        if (newVal) {
          this.selectRows = newVal
        } else {
          this.selectRows = []
        }
      },
      getStatus (newVal, oldVal) {
        if (newVal) {
          this.params.is_valid = this.isValid ? this.isValid : 'true'
          this.getAllTagList()
          this.getNewsList()
        }
      },
      sourceType (newVal, oldVal) {
        console.log(newVal)
        if (newVal) {
        }
      }
    },
    mounted () {
        this.getnewDataAreaManage()
    }
  }
</script>

<style type="text/css">
  .store-dialog .el-checkbox {
    display: inline;
  }
</style>



// WEBPACK FOOTER //
// index.vue?b123a5b8